import "../../../stylesheets/about-package/about.less";
import "../../../stylesheets/shared-package/shared.less";

import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import {compose} from "mu-lambda";
import * as React from "react";

import Link from "@khanacademy/wonder-blocks-link";
import {
    enums,
    withConversionContext,
    withMarkConversion,
    type PartialLearningTimeInfo,
    type WithMarkConversionProps,
    type WithoutMarkConversion,
} from "@khan/analytics-learning-time";

import PageRoot from "#app-shell-package/page-root.tsx";

import AboutHeader from "../about-header.tsx";
import AboutNav from "../about-nav.tsx";

import {withStrings} from "./locales/our-alumni/load-strings.tsx";
import TeamPageBody from "./team-page-body.tsx";

type OwnProps = Empty;
type Props = OwnProps & WithMarkConversionProps;

class AboutOurAlumni extends React.Component<Props> {
    defaultSearchBarPosition: unknown;

    componentDidMount() {
        this.props.markConversion({id: "alumni_page_view"});
    }

    render(): React.ReactNode {
        const footer = (
            <div style={{textAlign: "center"}}>
                <p>
                    <Trans>
                        Khan Academy has also received the time, energy, and
                        expertise of many{" "}
                        <Link href="/contribute/credits">
                            volunteers, and part-time contributors
                        </Link>
                        .
                    </Trans>
                </p>
            </div>
        );

        return (
            <PageRoot settings={{title: t`Alumni`}}>
                <div className="about-page">
                    <AboutHeader
                        pageheadline={t`Meet Our Alumni.`}
                        headercontent={
                            <a href="/careers" className="apply-button">
                                {t`Apply now`}
                            </a>
                        }
                    />
                    <AboutNav />
                    <TeamPageBody teamPageName="ALUMNI" footer={footer} />
                </div>
            </PageRoot>
        );
    }
}

const mapPropsToLearningTime = (): PartialLearningTimeInfo => {
    return {
        activity: enums.Activity.OTHER_ACTIVITY,
        product: enums.Product.OTHER_PRODUCT,
    };
};

type ExportProps = WithoutMarkConversion<
    JSX.LibraryManagedAttributes<
        typeof AboutOurAlumni,
        React.ComponentProps<typeof AboutOurAlumni>
    >
>;
export default compose(
    withStrings,
    withConversionContext(mapPropsToLearningTime),
    withMarkConversion,
)(AboutOurAlumni) as React.ComponentType<ExportProps>;
